//! DO NOT IMPORT FROM THIS FILE - USE './theme-selectors.ts' INSTEAD
export var getDefaultBadgeBackgroundColor = function (theme) {
    return theme.v1.badges.default.background;
};
export var getDefaultBadgeColor = function (theme) {
    return theme.v1.badges.default.color;
};
export var getPriceIndicatorFairBackgroundColor = function (theme) {
    return theme.v1.badges.priceIndicatorFair.background;
};
export var getPriceIndicatorFairColor = function (theme) {
    return theme.v1.badges.priceIndicatorFair.color;
};
export var getPriceIndicatorGoodBackgroundColor = function (theme) {
    return theme.v1.badges.priceIndicatorGood.background;
};
export var getPriceIndicatorGoodColor = function (theme) {
    return theme.v1.badges.priceIndicatorGood.color;
};
export var getPriceIndicatorGreatBackgroundColor = function (theme) {
    return theme.v1.badges.priceIndicatorGreat.background;
};
export var getPriceIndicatorGreatColor = function (theme) {
    return theme.v1.badges.priceIndicatorGreat.color;
};
export var getPriceIndicatorHighBackgroundColor = function (theme) {
    return theme.v1.badges.priceIndicatorHigh.background;
};
export var getPriceIndicatorHighColor = function (theme) {
    return theme.v1.badges.priceIndicatorHigh.color;
};
export var getPriceIndicatorLowBackgroundColor = function (theme) {
    return theme.v1.badges.priceIndicatorLow.background;
};
export var getPriceIndicatorLowColor = function (theme) {
    return theme.v1.badges.priceIndicatorLow.color;
};
export var getSavingBadgeBackgroundColor = function (theme) {
    return theme.v1.badges.saving.background;
};
export var getSavingBadgeColor = function (theme) {
    return theme.v1.badges.saving.color;
};
export var getWriteOffBadgeBackgroundColor = function (theme) {
    return theme.v1.badges.writeOff.background;
};
export var getWriteOffBadgeColor = function (theme) {
    return theme.v1.badges.writeOff.color;
};
